/* SUPERMAT — interactions du thème */
(function () {
  'use strict';

  /* ---- menu mobile ---- */
  var burger = document.querySelector('[data-menu-toggle]');
  var mobile = document.getElementById('mobile-nav');
  if (burger && mobile) {
    burger.addEventListener('click', function () {
      var open = mobile.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- galerie produit ---- */
  var main = document.getElementById('pdp-img');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---- quantité ---- */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentNode.querySelector('input');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10);
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---- sélection de variante ---- */
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-option-index]'));
    var chosen = groups.map(function (g) {
      var active = g.querySelector('.is-active');
      return active ? active.getAttribute('data-option-value') : '';
    });

    function sync() {
      var key = chosen.join(' / ');
      var match = Array.prototype.find.call(select.options, function (o) {
        return o.getAttribute('data-options') === key;
      });
      if (match) {
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        var priceEl = document.querySelector('.pdp__price');
        if (priceEl) priceEl.textContent = match.getAttribute('data-price');
        var submit = document.querySelector('.pdp__form button[type=submit]');
        if (submit) {
          submit.disabled = match.disabled;
          if (match.disabled) submit.textContent = submit.getAttribute('data-sold') || 'Épuisé';
        }
      }
    }

    groups.forEach(function (group, i) {
      group.querySelectorAll('.seg').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.seg').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          chosen[i] = btn.getAttribute('data-option-value');
          sync();
        });
      });
    });
  }

  /* ---- contrôles segmentés génériques (studio) ---- */
  document.querySelectorAll('[data-seg]').forEach(function (box) {
    box.querySelectorAll('.seg').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('.seg').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateStudioSpecs();
      });
    });
  });

  /* ---- interrupteur ---- */
  document.querySelectorAll('[data-switch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      sw.setAttribute('aria-pressed', sw.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });
  });

  /* ---- curseur de densité ---- */
  var density = document.querySelector('[data-density]');
  var densityOut = document.querySelector('[data-density-out]');
  var LABELS = { 1: 'Minimale', 2: 'Standard', 3: 'Dense' };
  if (density && densityOut) {
    density.addEventListener('input', function () {
      densityOut.textContent = LABELS[density.value] || 'Standard';
    });
  }

  /* ---- specs de l'aperçu studio ---- */
  function updateStudioSpecs() {
    var out = document.querySelector('[data-preview-specs]');
    if (!out) return;
    var fmt = document.querySelector('[data-seg-target="format"] .is-active');
    var frm = document.querySelector('[data-seg-target="frames"] .is-active');
    if (!fmt || !frm) return;
    out.textContent = fmt.textContent.trim() + ' cm · 300 dpi · cadres ' + frm.textContent.trim().toLowerCase();
  }

  /* ---- aperçu des fichiers importés (studio) ---- */
  var files = document.querySelector('[data-studio-files]');
  var slots = document.querySelector('[data-studio-slots]');
  if (files && slots) {
    files.addEventListener('change', function () {
      slots.innerHTML = '';
      Array.prototype.slice.call(files.files, 0, 6).forEach(function (file) {
        var cell = document.createElement('div');
        cell.className = 'slot';
        var img = document.createElement('img');
        img.style.cssText = 'width:100%;height:100%;object-fit:cover';
        img.alt = file.name;
        img.src = URL.createObjectURL(file);
        img.onload = function () { URL.revokeObjectURL(img.src); };
        cell.appendChild(img);
        slots.appendChild(cell);
      });
      var add = document.createElement('div');
      add.className = 'slot';
      add.textContent = '+ ajouter';
      slots.appendChild(add);
    });
  }

  /* ------------------------------------------------------------------
     Entites HTML dans les libelles du Studio

     Le filtre `t` de Shopify echappe le HTML : "Remplacer l'image"
     devient "Remplacer l&#39;image". Le JavaScript du Studio affecte
     ensuite ces chaines via textContent, qui rend l'entite telle quelle
     au lieu de l'apostrophe.

     On decode apres coup, sur les seuls elements que ce JS ecrit.
     Correctif place ici plutot que dans sections/studio.liquid : ce
     fichier fait 41 Ko de Liquid et de JavaScript imbriques, et l'API
     Shopify impose de renvoyer le fichier entier a chaque modification.
  ------------------------------------------------------------------ */
  (function () {
    var SEL = '.sa-replace, .sa-tapis, .sa-edit, .sa-cta, .sa-gen__t, .sa-err, .smc-rm, .smc-empty';

    function decode(s) {
      var d = document.createElement('textarea');
      d.innerHTML = s;
      return d.value;
    }

    function fixOne(el) {
      var t = el.textContent;
      if (!t || t.indexOf('&#') === -1) return;
      el.textContent = decode(t);
    }

    function sweep() {
      var list = document.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) fixOne(list[i]);
    }

    sweep();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sweep);
    }

    // Les boutons « convertir » et « modifier » n'existent qu'apres une
    // generation : on observe les ajouts, en groupant les passages.
    if (window.MutationObserver) {
      var pending = null;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; sweep(); }, 120);
      });
      var start = function () {
        if (document.body) mo.observe(document.body, { childList: true, subtree: true });
      };
      if (document.body) start();
      else document.addEventListener('DOMContentLoaded', start);
    }
  })();

  /* ------------------------------------------------------------------
     Studio, mobile : place le compteur de rendus (« 3 / 3 ») a cote du
     bouton « generer ».

     sections/studio.liquid le positionne en absolu par-dessus l'apercu,
     ce qui fonctionne sur grand ecran mais le fait flotter au milieu de
     l'image sur telephone. Sous 760 px on le deplace dans la barre
     d'actions ; au-dela on le remet a sa place d'origine.
  ------------------------------------------------------------------ */
  (function () {
    var BP = 760;

    function place() {
      var histo = document.querySelector('.sa-histo');
      var actions = document.querySelector('.sa-actions');
      if (!histo || !actions) return;

      var mobileNow = window.innerWidth <= BP;

      if (mobileNow && histo.parentNode !== actions) {
        var gen = actions.querySelector('button.sa-gen:not(.sa-edit):not(.sa-tapis):not(.sa-direct)');
        actions.insertBefore(histo, gen ? gen.nextSibling : actions.firstChild);
        histo.classList.add('sa-histo--inline');
        histo.setAttribute('data-sm-moved', '1');
      } else if (!mobileNow && histo.getAttribute('data-sm-moved')) {
        var stage = document.querySelector('.sa-stage');
        if (stage) {
          stage.appendChild(histo);
          histo.classList.remove('sa-histo--inline');
          histo.removeAttribute('data-sm-moved');
        }
      }
    }

    place();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
    window.addEventListener('resize', place);

    // Le compteur n'est cree qu'apres la premiere generation.
    if (window.MutationObserver) {
      var att = null;
      var mo3 = new MutationObserver(function () {
        if (att) return;
        att = setTimeout(function () { att = null; place(); }, 150);
      });
      var go = function () {
        if (document.body) mo3.observe(document.body, { childList: true, subtree: true });
      };
      if (document.body) go();
      else document.addEventListener('DOMContentLoaded', go);
    }
  })();
})();
